import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { buscaModelo } from "../../../types/modelo";
import { deleteModelo, getModelos } from "../../../api/modeloApi";
import { getFabricantes } from "../../../api/fabricanteApi";
import Tabela from "../../../components/Tabela";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Fabricante } from "../../../types/acao";

const Modelo: React.FC = () => {
  const [modelos, setModelos] = useState<buscaModelo[]>([]);
  const [fabricanteMap, setFabricanteMap] = useState<Record<number, string>>(
    {}
  );
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchModelosEFabricantes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }

        const fabricantesData = await getFabricantes(token);
        const fabricanteMapTemp: Record<number, string> = {};
        fabricantesData.forEach((fabricante: Fabricante) => {
          fabricanteMapTemp[fabricante.id] = fabricante.descricao_fabricante;
        });
        setFabricanteMap(fabricanteMapTemp);

        const modelosData = await getModelos(token);
        setModelos(modelosData);
      } catch (error) {
        toast.error("Erro ao buscar modelos ou fabricantes!");
        console.error("Erro ao buscar modelos ou fabricantes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchModelosEFabricantes();
  }, []);

  const handleAddModelo = () => {
    navigate("/adicionarModelo");
  };

  const handleEditModelo = (id: string) => {
    navigate(`/editarModelo/${id}`);
  };

  const handleDeleteModelo = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteModelo(token, id);
      setModelos(modelos.filter((modelo) => modelo.id !== Number(id)));
      toast.success("Modelo excluído com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir Modelo!");
      console.error("Erro ao excluir Modelo:", error);
    }
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "descricao_modelo", label: "Descrição do Modelo" },
    { id: "id_fabricante", label: "Fabricante" },
  ];

  const modelosComDescricaoFabricante = modelos.map((modelo) => ({
    ...modelo,
    id_fabricante: fabricanteMap[modelo.id_fabricante] || modelo.id_fabricante,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Modelos"
        colunas={colunas}
        dados={modelosComDescricaoFabricante}
        onAdd={handleAddModelo}
        onEdit={handleEditModelo}
        onDelete={handleDeleteModelo}
        loading={loading}
        showVisibilityIcon={false}
        onView={() => {}}
      />
    </Box>
  );
};

export default Modelo;
